import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { CompanyHubAuthCard } from "./CompanyHubAuthCard";
import HubPageWrapper from "./HubPageWrapper";
import { HubSurveysCard, NoSurveysCard } from "./HubSurveysCard";

export const CompanyHubPage = (
    { title, subtitle, field1, field2, companySlug, buttonRenamer },
    { t: _ },
) => {
    const legalText = useSelector((state) => state.company?.settings?.retain?.kiosk?.legal_text);
    const companyName = useSelector((state) => state.company?.name ?? "");
    const [firstName, setFirstName] = useState("");
    const [authenticated, setAuthenticated] = useState(false);
    const [surveyList, setSurveyList] = useState([]);
    const surveyListEmpty = surveyList.length === 0;

    const surveyTitle =
        title || _("Welcome to {company_name} Surveys!", { company_name: companyName });
    const pageSubtitle = subtitle || _("To begin your survey, please log in.");

    return (
        <HubPageWrapper className="hub" legalText={legalText} companyName={companyName}>
            {!authenticated && (
                <CompanyHubAuthCard
                    title={surveyTitle}
                    subtitle={pageSubtitle}
                    field1={field1}
                    field2={field2}
                    companySlug={companySlug}
                    buttonRenamer={buttonRenamer}
                    setAuthenticated={setAuthenticated}
                    setFirstName={setFirstName}
                    setSurveyList={setSurveyList}
                />
            )}
            {authenticated && (
                <>
                    {surveyListEmpty && <NoSurveysCard companyName={companyName} />}
                    {!surveyListEmpty && (
                        <HubSurveysCard firstName={firstName} surveyList={surveyList} />
                    )}
                </>
            )}
        </HubPageWrapper>
    );
};

CompanyHubPage.contextTypes = {
    t: PropTypes.func,
};

CompanyHubPage.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    field1: PropTypes.string.isRequired,
    field2: PropTypes.string.isRequired,
    companySlug: PropTypes.string.isRequired,
    buttonRenamer: PropTypes.object,
};

CompanyHubPage.defaultProps = {
    title: "",
    subtitle: "",
    buttonRenamer: {},
};

export default React.memo(CompanyHubPage);
